import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-download-app-buttons',
  imports: [NgOptimizedImage],
  templateUrl: './download-app-buttons.component.html',
})
export class DownloadAppButtonsComponent {
  // App identifiers
  private readonly PLAY_STORE_PACKAGE = 'com.byteorbit.paystashio';
  private readonly APP_STORE_ID = '6566187530';

  // Generate Play Store URL with UTM tracking
  readonly playStoreUrl = this.buildPlayStoreUrl();
  // Generate App Store URL with UTM tracking
  readonly appStoreUrl = this.buildAppStoreUrl();

  /**
   * Build Google Play Store URL with UTM parameters for tracking
   */
  private buildPlayStoreUrl(): string {
    const params = new URLSearchParams({
      id: this.PLAY_STORE_PACKAGE,
      utm_source: 'website',
      utm_medium: 'download_button',
      utm_campaign: 'app_download',
    });
    return `https://play.google.com/store/apps/details?${params}`;
  }

  /**
   * Build Apple App Store URL with campaign tracking
   */
  private buildAppStoreUrl(): string {
    const params = new URLSearchParams({
      ct: 'website_download', // Campaign token
      mt: '8', // Media type (8 = iOS app)
    });
    return `https://apps.apple.com/za/app/paystashio/id${this.APP_STORE_ID}?${params}`;
  }

  /**
   * Handle Play Store button click
   * Tries to open the app if installed, otherwise opens Play Store
   */
  onPlayStoreClick(event: Event): void {
    event.preventDefault();

    const isMobile = /Android/i.test(navigator.userAgent);

    if (isMobile) {
      // Try to open the app using market:// protocol
      globalThis.location.href = `market://details?id=${this.PLAY_STORE_PACKAGE}`;

      // Fallback to web URL if app not installed
      setTimeout(() => {
        window.open(this.playStoreUrl, '_blank', 'noopener,noreferrer');
      }, 500);
    } else {
      // Desktop: Just open Play Store web
      window.open(this.playStoreUrl, '_blank', 'noopener,noreferrer');
    }
  }

  /**
   * Handle App Store button click
   * On iOS devices, tries to open the app directly using App Store URL
   * iOS automatically opens the app if installed, or App Store if not
   */
  onAppStoreClick(event: Event): void {
    event.preventDefault();

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isIOS) {
      // On iOS, use direct navigation (iOS will open app if installed)
      globalThis.location.href = this.appStoreUrl;
    } else {
      // On other devices, open in new tab
      window.open(this.appStoreUrl, '_blank', 'noopener,noreferrer');
    }
  }
}
